import { get, put, putForm, postForm } from 'utils/methods';

export function getStoreApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}stores`, data, headers);
}

export function addStoreApi(data, headers) {
    return postForm(`${process.env.REACT_APP_REST}commands/store`, data, headers);
}

export function editStoreApi(data, headers) {
    return putForm(`${process.env.REACT_APP_REST}commands/store`, data, headers);
}

export function toggleStoreStatusApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/store/status`, data, headers);
}
